import { AccountPost, AccountPostSchema } from "callable-data-objects";
import { CallableInput, CountrySelect } from "Components/Shared";
import ASRSelect from "Components/Shared/ASRSelect";
import FormSubmit from "Components/Shared/FormSubmit";
import OrganisationSelect from "Components/Shared/OrganisationSelect";
import TimezoneSelect from "Components/Shared/TimezoneSelect";
import TTSSelect from "Components/Shared/TTSSelect";
import { Field, Formik } from "formik";
import React, { Fragment, useState } from "react";
import AddressSearch from "react-loqate";
import {
  Accordion,
  Breadcrumb,
  Button,
  Card,
  Container,
  Divider,
  Form,
  Header,
  Icon,
  Menu,
  MenuItem,
} from "semantic-ui-react";

type AccountCreateProps = {
  create: AccountPost;
  save: Function;
  validateName: Function;
  validateDomain: Function;
  cancel: Function;
};

function AccountCreate({
  create,
  save,
  validateName,
  validateDomain,
  cancel,
}: AccountCreateProps) {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [showAddress, setShowAddress] = useState(true);

  return (
    <Fragment>
      <Menu>
        <MenuItem header>
          <Breadcrumb>
            <Breadcrumb.Section link onClick={() => cancel()}>
              Accounts
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section>Create Account</Breadcrumb.Section>
          </Breadcrumb>
        </MenuItem>
      </Menu>

      <Container textAlign='left' style={{ paddingTop: "40px" }}>
        <Header as='h3'>Create New Account</Header>
        <Divider />
        <Formik
          validateOnChange={true}
          enableReinitialize={true}
          initialValues={create}
          validationSchema={AccountPostSchema}
          onSubmit={(values, actions) => {
            save(values);
          }}
        >
          {({
            handleSubmit,
            setFieldValue,
            errors,
            validateField,
            values,
            validateForm,
          }) => (
            <Form onSubmit={handleSubmit}>
              <OrganisationSelect name='organisation' label='Organisation' />
              <Field
                name='name'
                label='Name'
                validate={validateName}
                component={CallableInput}
              />
              <Field
                name='domain'
                label='Domain'
                validate={validateDomain}
                component={CallableInput}
              />

              <Form.Field>
                {showAddress && (
                  <Fragment>
                    <label>Find Address</label>
                    <AddressSearch
                      locale='en_GB'
                      apiKey='NH39-EP22-RK79-FH43'
                      countries={["GB"]}
                      // components={{ Input: AddressSearchInput }}
                      listItemClassname='list-item'
                      onSelect={(address) => {
                        setFieldValue("address.line1", address.Line1);
                        setFieldValue("address.line2", address.Line2);
                        setFieldValue("address.postalCode", address.PostalCode);
                        setFieldValue("address.country", address.CountryName);
                        setFieldValue("address.level2", address.City);
                        setFieldValue(
                          "address.level1",
                          address.ProvinceName || address.City
                        );
                        setShowAddress(false);
                        validateField("address");
                      }}
                    />
                  </Fragment>
                )}
                {!showAddress && (
                  <Card fluid style={{ padding: "20px" }}>
                    <Card.Content>
                      <Field
                        name='address.line1'
                        label='Building Name / Number'
                        component={CallableInput}
                      />

                      <Field
                        name='address.line2'
                        label='Street'
                        component={CallableInput}
                      />

                      <Field
                        name='address.level2'
                        label='City'
                        component={CallableInput}
                      />

                      <Field
                        name='address.level1'
                        label='County'
                        component={CallableInput}
                      />

                      <Field
                        name='address.postalCode'
                        label='Postcode'
                        component={CallableInput}
                      />

                      <Field
                        name='address.country'
                        label='Country'
                        component={CallableInput}
                      />
                    </Card.Content>
                    <Card.Content>
                      <Button
                        basic
                        color='blue'
                        onClick={() => setShowAddress(true)}
                      >
                        Choose different address
                      </Button>
                    </Card.Content>
                  </Card>
                )}
              </Form.Field>

              <br />
              <Accordion>
                <Accordion.Title
                  active={showAdvanced}
                  index={0}
                  onClick={() => setShowAdvanced(!showAdvanced)}
                >
                  <Icon name='dropdown' />
                  Advanced
                </Accordion.Title>
                <Accordion.Content active={showAdvanced}>
                  <Card fluid style={{ padding: "20px" }}>
                    <Card.Content>
                      <CountrySelect
                        name='countryCode'
                        label='Presentation Country'
                      />

                      <TimezoneSelect name='timezone' label='Time Zone' />

                      <TTSSelect name='ttsLanguage' label='TTS Language' />

                      <ASRSelect name='asrLanguage' label='ASR Language' />
                    </Card.Content>
                  </Card>
                </Accordion.Content>
              </Accordion>
              <br />
              <FormSubmit name='Create Account' errors={errors} />
            </Form>
          )}
        </Formik>
      </Container>
    </Fragment>
  );
}

export default AccountCreate;
